import httpClient from "@/config/httpClient";
import { uiStore, userStore } from "@/mobx/rootStore";
import { routesList } from "@/routesList";

export async function repair() {
	httpClient.headers.Authorization = "";
	userStore.reset();
	uiStore.reset();

	// Remove all localStorage data
	localStorage.clear();

	window.location.href = routesList.login.path;
}
